import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    background: p => `rgba(${hexToRgb(p.tertiaryDark)}, 1)`,
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite
  },
  LIGHT: {
    background: p => `rgba(${hexToRgb(p.tertiaryLight)}, 1)`,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal
  },
  EXTRALIGHT: {
    background: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 1)`,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal
  }
}
